import { ruleExecutionLogSchema } from '../models/ruleExecutionLog.schema';

export const get = (requestId: string) => {
  return {
    endpoint: `/rules_execution_logs/${requestId}`,
    method: 'GET',
    responseSchema: ruleExecutionLogSchema,
  } as const;
};
